export default __webpack_public_path__ + "static/media/S-004.f3c5dcf1.png";